export const en = {
    generalErrorMessage: {
        fieldIsRequired: 'field is required',
    },
    Common: {
        add: 'Add',
        cancel: 'Cancel',
        close: 'Close',
        loading: 'Loading',
        no_data_found: 'No data found',
        save: 'Save',
        search: 'Search',
        attachment: 'Attachment',
        image: 'Image',
        video: 'Video',
        audio_message: 'Audio',
        pdf: 'PDF',
        spreadsheet: 'Spreadsheet',
        sticker: 'Sticker',
        an_error_occurred: 'An error occurred',
    },
    RecurringTask: {
        title: 'Recurrence',
        add: 'Add recurrence',
        set: 'Set recurring',
        dates: 'Dates',
        start: 'Start',
        due: 'Due',
        start_date: 'Start date',
        due_date: 'Due date',
        today: 'Today',
        tomorrow: 'Tomorrow',
        this_weekend: 'This weekend',
        next_week: 'Next week',
        next_weekend: 'Next weekend',
        two_weeks: '2 weeks',
        four_weeks: '4 weeks',
        clear: 'Clear',
        dates_updated: 'Task dates updated successfully.',
        every: 'Every',
        day: 'day(s)',
        week: 'week(s)',
        month: 'month(s)',
        until: 'Until',
        remove: 'Remove recurrence',
        invalid_rule: 'Check the recurrence interval and end date.',
        due_required: 'Set a due date before adding recurrence.',
        saved: 'Recurrence saved successfully.',
        removed: 'Recurrence removed successfully.',
        create_when: 'Create',
        on_schedule: 'On schedule',
        on_complete: 'When complete',
        on_status_complete: 'On status change: Complete',
        daily: 'Daily',
        weekly: 'Weekly',
        monthly: 'Monthly',
        yearly: 'Yearly',
        custom: 'Custom',
        year: 'year(s)',
        create_new_task: 'Create new task',
        recur_forever: 'Recur forever',
        update_status_to: 'Update status to:',
        sync_to_due_date: 'Sync recurrence to due date',
        saved_not_scheduled: 'Recurrence saved, but the schedule could not be queued yet. It will be retried automatically.',
        status_required_when_reusing: 'Required so the task reopens and can recur again.',
    },
    eoffice: {
        home: 'E-Office Home',
        back_home: 'Back to E-Office Home',
        hero_title: 'Your enterprise digital workspace',
        hero_description: 'Follow the latest information and quickly access every application group in one place.',
        applications: 'Applications',
        choose_workspace: 'Choose where you want to work',
        available_applications: '{count} applications available',
        latest_news: 'Latest news',
        news_for_you: 'Company announcements and internal content for you',
        view_all: 'View all →',
        loading_news: 'Loading news...',
        news_fallback: 'View the latest company announcement.',
        explore_now: 'Explore now →',
        news_updating: 'System news is being updated.',
        workbench: 'Workbench',
        categories: 'Categories',
        news: 'News',
        announcements: 'Announcements',
        album_library: 'Albums & library',
        employee_directory_short: 'Employee directory',
        happy_birthday: 'Happy birthday',
        upcoming_birthday: 'Upcoming birthday',
        employee: 'Employee',
        colleague_birthday: 'Colleague birthdays',
        no_upcoming_birthday: 'There are no upcoming birthdays.',
        view_employee_directory: 'View employee directory',
        coming_soon: 'Coming soon',
        purchasing: 'Purchasing',
        digital_process: 'Digital Process',
        digital_office: 'Digital Office',
        workflow_catalog: 'Catalog & Workflows',
        office_applications: 'Office applications',
        choose_utility: 'Choose the utility you want to use',
        weekly_schedules: 'Weekly schedules',
        weekly_schedules_description: 'View and create organization work schedules',
        employee_directory: 'Employee directory',
        employee_directory_description: 'Look up employee and organization information',
        outgoing_documents: 'Outgoing documents',
        outgoing_documents_description: 'Manage issued documents',
        incoming_documents: 'Incoming documents',
        incoming_documents_description: 'Receive and process documents',
        authorizations: 'Authorizations',
        authorizations_description: 'Track authorization records and expiration dates',
        shared_documents: 'Shared documents',
        shared_documents_description: 'Update and manage shared documents',
        internal_library: 'Internal library',
        internal_library_description: 'Browse authorized internal documents',
        company_news: 'Announcements & News',
        company_news_description: 'Get the latest company updates',
        digital_signatures: 'Digital signatures',
        digital_signatures_description: 'Create and manage personal signature templates',
        tickets: 'Operational workflows (Tickets)',
        office_supplies: 'Office supplies',
        payment_requests: 'Payment requests',
        advance_requests: 'Advance requests',
        business_trips: 'Business trips',
        business_cars: 'Business cars',
        meeting_rooms: 'Meeting rooms',
        supply_proposals: 'Supply proposals',
        supply_proposals_description: 'Create and track supply proposals',
        purchase_requests: 'Purchase requests',
        purchase_requests_description: 'Create purchase request records',
        purchase_orders: 'Purchase orders',
        purchase_orders_description: 'Manage orders and deliveries',
        purchase_prices: 'Purchase prices',
        purchase_prices_description: 'Look up prices and suppliers',
        pending_approval: 'Records waiting for your approval',
        pending_purchase_approval: 'Purchase records waiting for approval',
        pending_ticket_action: 'Tickets waiting for your action',
        purchasing_description: 'Supply proposals, purchasing, and price management',
        digital_process_description: 'Create, track, and approve internal workflows',
        digital_office_description: 'Schedules, directory, and office utilities',
        workflow_catalog_description: 'Manage shared catalogs and business workflow settings',
        link: 'Link',
        internal_news: 'Internal news',
        news_load_failed: 'News cannot be loaded right now.',
        fallback_news_1_title: 'Work more efficiently in Kompact Digital Office',
        fallback_news_1_description: 'News, pending approvals, and internal workflows are available in one place.',
        fallback_news_2_title: 'Track supply and purchase requests more easily',
        fallback_news_2_description: 'Check record status and handle purchasing work directly from your workbench.',
        fallback_news_3_title: 'Digital workflows keep every step up to date',
        fallback_news_3_description: 'Track assignees, approval history, and record progress transparently.',
        fallback_news_4_title: 'Never miss an important internal announcement',
        fallback_news_4_description: 'The latest company information is always available on the home page.',
        fallback_news_5_title: 'Connect quickly through the employee directory',
        fallback_news_5_description: 'Find colleague contact, company, and department information when needed.',
    },
    notes: {
        title: 'Notes',
        default_note_name: 'Default Note Name',
        create_new_note: 'New Note',
        name: 'Name',
        creation_date: 'Creation Date',
        modification_date: 'Modification Date',
        creator: 'Creator',
        search: 'Search',
        rename: 'Edit Note Name',
        delete: 'Delete Note',
        pin: 'Pin Note',
        unpin: 'Unpin Note',
        untitled: 'Untitled',
        no_notes: 'No notes found',
        all_notes_filter: 'All notes',
        my_notes_filter_option: 'My notes',
        shared_with_me_filter: 'Shared with me',
        pinned_filter: 'Pinned',
        last_modified: 'Last modified',
        last_created: 'Last created',
        name_az: 'Name A-Z',
        name_za: 'Name Z-A',
        filter: 'Filter',
        sort: 'Sort',
        category: 'Category',
        create: 'Create',
        all_categories: 'All categories',
        no_category: 'No category',
        category_name: 'Category name',
        move_to_category: 'Move to category',
        shared_with: 'Shared with',
        add_file: 'Add file',
        share: 'Share',
        share_note: 'Share note',
        select_people: 'Select people',
        view_only: 'View only',
        can_edit: 'Can edit',
        remove: 'Remove',
        no_access_yet: 'No one has access yet',
        manage_sharing: 'Manage sharing',
        share_updated: 'Note sharing updated',
        share_update_failed: 'Could not update note sharing',
        export_word: 'Export Word',
        export_word_title: 'Export as a Word file',
        drag_to_move: 'Drag to move',
        breadcrumb: 'Note path',
        pagination_summary: '{from}–{to} / {total} notes',
        page_status: 'Page {current}/{total}',
        previous_page: 'Previous page',
        next_page: 'Next page',
        select_note: 'Select a note',
        delete_confirm_message: 'Are you sure you want to delete this note? This action cannot be undone.',
        delete_category: 'Delete category',
        delete_category_confirm_message: 'Delete “{name}”? Notes in this category will be moved to No category.',
        failed_delete: 'Failed to delete note',
        failed_delete_category: 'Failed to delete category',
        failed_update_pin: 'Failed to update pin status',
        failed_update_title: 'Failed to update note title',
        user: 'User',
        you: 'You',
    },
    Comments: {
        add_to_checklist: 'Add to checklist',
        comment: 'Comment',
        comments: 'Comments',
        copy_message: 'Copy message',
        create_task: 'Create task',
        edit: 'Edit',
        edited: 'Edited',
        less: 'Less',
        mark_unread: 'Mark as unread',
        message: 'message',
        more: 'More',
        no_user_found: 'No user found',
        reply: 'Reply',
        This_message_is_deleted: 'This message was deleted',
        unlock_comment_view: 'Unlock comments',
        unread_message: 'unread messages',
    },
    Kpi: {
        approval: 'Approver',
        assignee_added_successfully: 'Assignee added successfully',
        assignee_change_request_sent: 'Assignee change request sent for approval',
        assignee_removed_successfully: 'Assignee removed successfully',
        assignee_replaced_successfully: 'Assignee replaced successfully',
        assignee_required: 'Assignee is required.',
        auto_calculated_time: 'Automatically calculated from task dates',
        bonus: 'Bonus',
        bonus_score: 'Bonus score',
        cannot_mark: 'Unable to mark this task as KPI',
        cannot_unmark: 'Unable to remove KPI from this task',
        comment: 'Comment',
        confirm: 'Approve',
        confirm_failed: 'KPI approval failed',
        confirm_lock_task: 'Approve and lock task',
        confirm_scoring_prefix: 'After approval, the score will be',
        confirm_scoring_suffix: 'and the task can no longer be edited. Continue?',
        confirm_task_completion: 'Approve task completion',
        confirmed: 'Approved',
        description_required: 'Description is required.',
        due_date_change_request_sent: 'Due date change request sent for approval',
        due_date_must_be_after_start_date: 'Due date must be on or after {date}.',
        due_date_required: 'Due date is required.',
        feedback_placeholder: 'Add feedback for the assignee',
        grade_average: 'Average',
        grade_good: 'Good',
        grade_low: 'Needs improvement',
        invalid_task: 'Invalid task',
        kpi: 'KPI',
        kpi_confirmed: 'KPI approved successfully',
        kpi_rejected: 'KPI rejected successfully',
        kpi_unmarked: 'KPI removed successfully',
        locked: 'locked',
        marked_auto_confirmed: 'Task marked as KPI and automatically approved',
        no_approval: 'No approver assigned',
        no_permission: 'You do not have permission to perform this action',
        old: 'Previous',
        only_approval_can_close_score: 'Only the assigned approver can approve completion and score this task',
        only_approval_can_confirm: 'Only the assigned approver can approve this KPI',
        only_approval_can_reject: 'Only the assigned approver can reject this KPI',
        only_approval_can_score: 'Only the assigned approver can score this KPI task',
        only_approver_can_review_request: 'Only the assigned approver can review this request',
        only_assignee_or_approval_can_edit: 'Only the assignee or assigned approver can edit this KPI task',
        only_assignee_or_approval_can_turn_on: 'Only the assignee or assigned approver can enable KPI',
        only_managers_can_close: 'Only the assigned manager can complete a KPI task',
        only_one_assignee: 'A KPI task can only have one assignee.',
        pending: 'Pending',
        quality_locked_reason: 'Quality score is limited because this task was reopened {count} time(s).',
        quality_reopen_reason: 'After reopening, the maximum quality score is {score}/{max}.',
        quality_score: 'Quality score',
        reject: 'Reject',
        reject_failed: 'KPI rejection failed',
        rejected: 'Rejected',
        reporter_required: 'Reporter is required.',
        request_not_found: 'Pending request not found',
        scored_successfully: 'KPI task scored successfully',
        scoring_results: 'Scoring results',
        start_date_change_request_sent: 'Start date change request sent for approval',
        start_date_must_be_before_due_date: 'Start date must be on or before {date}.',
        start_date_required: 'Start date is required.',
        submit: 'Submit score',
        submit_failed: 'Unable to submit KPI score',
        submitting: 'Submitting...',
        task_scoring: 'KPI task scoring',
        time_score: 'Time score',
        title_required: 'Title is required.',
        total_score: 'Total score',
        updated_at: 'Updated {date}',
        value: 'Value',
        waiting: 'Waiting for approval',
        waiting_manager_cannot_close: 'This KPI task is still waiting for manager approval',
    },
    Chat: {
        leave_group_title: 'Leaving the group chat?',
        leave_group_confirm_text: 'Are you sure you want to leave this group?',
        transfer_ownership_title: 'Transfer ownership',
        transfer_ownership_desc: 'Please select a new owner for the group before leaving.',
        search_members: 'Search members',
        transfer_and_leave: 'Transfer & Leave',
        rename_chat: 'Rename Chat',
        rename_chat_desc: 'Type a new chat name to update this conversation.',
        create_group_chat_title: 'Create Group Chat',
        group_name: 'Group Name',
        group_name_placeholder: 'Enter group name',
        selected_members: 'Selected members',
        add_member_title: 'Add Member',
        group_avatar_title: 'Group Avatar',
        allow_group_members_to: 'Allow group members to',
        change_group_name_avatar: 'Change the group name & avatar',
        pin_message: 'Pin message',
        send_messages: 'Send messages',
        create_group_button: 'Create Group',
        group_create_validation: 'Please enter group name and select at least 2 members',
        group_created_successfully: 'Group created successfully',
        left_group_success: 'You left the group',
        left_group_failed: 'Failed to leave group',
        select_new_owner_required: 'Please select a new owner before leaving the group',
        invalid_new_owner: 'The selected owner must already be a group member',
        you_left_group: 'You left the group',
        left_group_suffix: 'left the group',
        group_member: 'Group member',
        group_member_count_one: '{count} member',
        group_member_count_other: '{count} members',
        owner: 'Owner',
        admin: 'Admin',
        unknown: 'Unknown',
        no_permission_to_pin_messages: "You don't have permission to pin messages",
        no_users_selected_yet: 'No users selected yet',
        share: 'Share',
        share_message_title: 'Share message',
        share_message_search_placeholder: 'Search private chats or group chats',
        share_message_preview_label: 'Message preview',
        share_message_group_chat: 'Group chat',
        share_message_private_chat: 'Private chat',
        share_message_empty: 'No conversations found',
        share_message_caption_label: 'Caption',
        share_message_caption_placeholder: 'Add a message (optional)',
        share_message_submitting: 'Sharing...',
        share_message_failed: 'Could not share message.',
    },
    Channel: {
        create_new_channel: 'Create Channel',
        channel_name_label: 'Channel Name',
        channel_name_placeholder: 'Enter channel name',
        private_group_chat: 'Private Channel',
        private_group_chat_desc: 'Only selected members and roles will be able to view this channel',
        send_messages: 'Send messages',
        send_messages_desc: 'Allows members to send messages in this channel.',
        create_channel_button: 'Create Channel',
        msg1: 'You do not have permission to create channels',
        icons: 'Icons',
        or: 'or',
        choose_to_upload: 'Choose to upload',
        only_share_with: 'Only share with'
    },
    ChatDetail: {
        type_a_message: 'Type a message'
    },
    ContactInfo: {
        information: 'Information',
        add_member: 'Add Members',
        mute_notifications: 'Mute notifications',
        unmute: 'Unmute',
        files: 'Files',
        members_title: 'Members',
        members_count: 'Members ({count})',
        images_videos: 'Images / Videos',
        no_media_yet: 'No media yet.',
        no_files_yet: 'No files yet.',
        view_all: 'View all',
        reply_to: 'Reply to',
        manage_group: 'Manage Group',
        delete_group: 'Delete group'
    },
    HapticMenu: {
        pin: 'Pin',
        unpin: 'Unpin'
    },
    SystemMessage: {
        owner_changed_me: 'You transferred group ownership to {target}',
        owner_changed: '{actor} transferred group ownership to {target}',
    },
    ChatSidebar: {
        search: 'Search',
        channel: 'Channel',
        chat: 'Chat',
        all: 'All',
        unread: 'Unread',
        group: 'Group',
        private: 'Private',
        users: 'Users',
        create_channel: 'Create Channel',
        delete_category: 'Delete Category',
        delete_category_title: 'Delete Category',
        delete_chat_title: 'Delete Chat',
        turn_notification_on: 'Turn notification on',
        turn_notification_off: 'Turn notification off',
        hide_conversation: 'Hide conversation',
        unhide_conversation: 'Unhide conversation',
        pin_conversation: 'Pin conversation',
        unpin_conversation: 'Unpin conversation',
        image_message: 'Hình ảnh',
        video_message: 'Video'
    },
    PlaceHolder: {
        Enter_Description: 'Enter description',
        Enter_Key_Name: 'Enter key name',
        Enter_Project_Name: 'Enter project name',
        Enter_Template: 'Enter template',
        Enter_Template_Name: 'Enter template name',
        Project_key_must_be_unique: 'Project key must be unique',
        Select_Project_Due_Date: 'Select project due date',
        enter_task_type: 'Enter task type',
        search: 'Search',
    },
    Profile: {
        phone_required_title: 'Update phone number',
        phone_required_message: 'Please update your phone number in settings before continuing.',
        go_to_settings: 'Go to settings',
        message: 'Message',
        opening_chat: 'Opening...',
    },
    ProjectSlider: {
        archived_list: 'Archived list',
        folder_name: 'Folder name',
        hide_archive: 'Hide archive',
        new_project: 'New Project',
        no_activity_log_found: 'No activity log found',
        no_archived: 'No archived projects found',
        no_project_found: 'No project found',
        no_result_found: 'No result found',
        overview: 'Overview',
        project_name: 'Project name',
        project_search_filter: 'Project search filter',
        projects: 'Projects',
        select_project_status: 'Select project status',
        show_archive: 'Show archive',
        sprint_name: 'Sprint name',
        try_using_diff: 'Try using different keywords',
        view_active: 'View active',
        you_dont: "You don't have permission",
    },
    //Login Process Messages
    authErrorMessage: {
        emailError: 'The email field must be a valid email',
        passwordValid: 'The password field must be at least 8 characters',
        currentPasswordValid: 'The current password field must be at least 8 characters',
        newPasswordValid: 'The new password field must be at least 8 characters',
        validPassRegex: 'passwords must be at least 8 characters long, and contain at least 1 alphabet,1 uppercase, 1 numeric, and 1 special character',
        confirmPasswordValid: 'The confirm password confirmation does not match',
        validCharactersfirst: 'The first name field may only contain alphabetic characters as well as spaces',
        validCharacterslast: 'The last name field may only contain alphabetic characters as well as spaces',
        minMust: 'must be at least 3 characters',
        currentPassword:'current passwords must be at least 8 characters long, and contain at least 1 alphabet,1 uppercase, 1 numeric, and 1 special character',
        newPassword:'new passwords must be at least 8 characters long, and contain at least 1 alphabet,1 uppercase, 1 numeric, and 1 special character'
    },
    //Create Company Process Messages
    companyErrorMessage: {
        phoneNumberValid:'The phone number field must be at least 10 characters'
    },
    email: 'Email',
    password: 'Password',
    firstName:'first name',
    lastName:'last name',
    phoneNumber:'phone number',
    currentPassword:'current password',
    newPassword:'new password'
}

export const english = en;
